<template>
  <section :id="data.id" class="bg-gray-lighten3 pb-20 pt-6 md:pb-28 md:pt-14">
    <div class="container">
      <div class="mb-6 flex gap-x-2 overflow-auto md:mb-12">
        <component
          :is="tag.link && tag.link.src ? UiLink : 'span'"
          v-for="(tag, i) in data.tags"
          :key="i"
          :to="tag.link && tag.link.src"
        >
          <UiTag rounded="2xl" size="lg" color="blue">
            <span v-html="tag.text" />
          </UiTag>
        </component>
      </div>
      <div class="mb-6 md:mb-12">
        <h1
          v-if="data.title"
          class="title text-3xl font-bold uppercase md:text-5xl"
          v-html="data.title"
        />

        <p
          v-if="data.description"
          class="mt-2 text-md"
          v-html="data.description"
        />
      </div>
    </div>
    <ServiceCenters />
  </section>
</template>

<script setup lang="ts">
import UiLink from '~/components/ui/UiLink.vue';

interface Props {
  data?: {
    id?: string;
    title?: string;
    description?: string;
    tags?: any[];
  };
}

withDefaults(defineProps<Props>(), {
  data: () => ({
    id: '',
    title: '',
    description: '',
    tags: [],
  }),
});
</script>
